module.exports = __webpack_public_path__ + "static/media/zone.ab1b1935.svg";